import { Box, Text } from '@chakra-ui/react';
import { Info, Notification } from '@whitbread-eos/atoms';
import { useTranslation } from 'next-i18next';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var OpeningSoonNotification = _ref => {
  var hotelAvailabilityResponse = _ref.hotelAvailabilityResponse,
    isHotelOpeningSoon = _ref.isHotelOpeningSoon,
    hotelName = _ref.hotelName,
    hotelOpeningDate = _ref.hotelOpeningDate,
    language = _ref.language;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var isLoading = hotelAvailabilityResponse.isLoadingHotelAvailability;
  var isError = hotelAvailabilityResponse.isErrorHotelAvailability;
  var error = hotelAvailabilityResponse.errorHotelAvailability;
  if (isLoading) {
    return _jsx(_Fragment, {});
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!isHotelOpeningSoon) {
    return null;
  }
  var formattedOpeningDate = hotelOpeningDate && new Date(hotelOpeningDate).toLocaleDateString(language === 'en' ? 'en-GB' : 'de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return _jsx(Box, {
    mt: {
      base: 'md',
      lg: '6'
    },
    "data-testid": "opening-soon-notification",
    children: _jsx(Notification, {
      title: "",
      description: "".concat(hotelName, " ").concat(t('hoteldetails.openingDateText'), " ").concat(formattedOpeningDate),
      status: "info",
      variant: "info",
      svg: _jsx(Info, {}),
      maxW: {
        base: 'full'
      },
      lineHeight: "2",
      prefixDataTestId: "opening-soon-notification"
    })
  });
};